//---------- Support tickets (Doctorite support service; this backend only signs the user)
export const supportIdentityURL = "api/support/identity"

//---------- User Login

export const userLoginURL = "loginPortal"
export const authTokenURL = "oauth/token"
export const userProfileURL = "user/userProfile"
export const forgotPasswordURL = "user/forgetPassword"
export const setNewPasswordURL = "user/setNewPassword"
export const fetchTimeZoneURL = "fetchTimeZone"
export const fetchStatesURL = "fetchStates"
export const fetchCountriesURL = "fetchCountries"
export const getBlockoutDaysURL = "ScheduleAudit/getScheduleAudit"
export const inserOrUpdateBlockoutURL =
    "ScheduleAudit/insertOrUpdateScheduleAudit"
export const getClinicsUserURL = "user/getClinicsUser"
export const getSDOHStatusByPatientURL = "mcqdone/getSDOHStatusByPatient"
export const updateLoginUserProfileURL = "user/updateUserProfileDetails"
export const getUsersURL = "user/getUsers"
export const getInternsBySupervisorURL = "user/getInternsBySupervisor"
export const getAllRolesURL = "role/getAll"
export const insertOrUpdateUserRolesURL = "user/insertUserBasedOnRole"
export const getPrivilegesURL = "user/getPrivileges"
export const addOrUpdateRoleURL = "role/addOrUpdate"
export const uploadPatientsXlsxURL = "user/patient/uploadxlsx"
export const userClinicMapURL = "user/userClinicMap"
export const userProgramMapURL = "user/userProgramMap"
export const deleteUserURL = "user/deleteUser"
export const activateUserURL = "user/activateUser"
export const getUserTypesURL = "user/getUserTypes"
export const generatePasswordResetLinkURL = "user/generatePasswordResetLink"
export const fetchProgramsURL = "fetchPrograms"
export const fetchCPTCodesUrl = "getCPTCODES"
export const insertOrUpdateClinicLevelCPTCODESUrl =
    "insertOrUpdateClinicLevelCPTCODES"
export const insertOrUpdateClinicLevelICDCODESUrl =
    "insertOrUpdateClinicLevelICDCODES"
export const insertOrUpdateClinicLevelDSMCODESUrl =
    "insertOrUpdateClinicLevelDSMCODES"
export const updateSaasUSerOnBoardUrl = "saas/updateSaasUSerOnBoard"
export const insertMcqOrgClinicMapUrl = "mcqdone/insertMcqOrgClinicMap"
export const getNotesForSupervisiorUrl = "getNotesForSupervisior"
export const getPatientDetailsAtappointmentLevelUrl =
    "getPatientDetailsAtappointmentLevel"
export const addOrUpdatePatientPaymentMethodUrl =
    "addOrUpdatePatientPaymentMethod"

//documents
export const getDocumentsURL = "documents"
export const uploadDocumentURL = "documents/uploadDocument"

//invoices
export const getInvoiceURL = "fetchInvoice"
export const insertInvoicePaidAmountURL = "insertInvoicePaidAmount"
export const getBillablePatientListURL = "getBillablePatientList"
export const downloadMultiPatientSummaryURL = "downloadMultiPatientSummary"

//organization
export const fetchOrganisationsURL = "fetchOrganizations"
export const fetchOrganizationDetailsURL = "fetchOrganizationDetails"
export const insertOurUpdateOrgURL = "insertOrUpdateOrganization"
export const orgProgramMapURL = "orgProgramMap"

//clinic
export const fetchClinicsURL = "fetchClinics"
export const insertOurUpdateClinicURL = "insertOrUpdateClinic"
export const insertOrUpdateNavigatorUrl = "insertOrUpdateNavigator"

//--- patients

export const fetchPatientsURL = "fetchPatients"
// Slim list (id, name, mobileNo, gender, dob, ehrPatientId) for the patients table
export const fetchPatientsLightWeightURL = "fetchPatientsLightWeight"
export const timeTrackerURL = "timeTracker"
export const userTimeTrackingBasedOnCategoryURL =
    "userTimeTrackingBasedOnCategory"
export const updateUserTimeTrackingBasedOnCategoryURL =
    "updateUserTimeTrackingBasedOnCategory"
export const fetchByMCQCodeAndPatientURL = "mcqdone/getByMCqCodeAndPatient"
export const fetchPatientById = "fetchPatientById"
export const lastConnectedURL = "callLogs/lastConnected"
export const insertOrUpdatePatientURL = "insertOrUpdatePatient"
export const insertOrUpdatePatientSymptomURL = "insertOrUpdatePatientSymptom"
export const insertOrUpdatePatientEnergiesURL = "insertOrUpdatePatientEnergies"
export const insertMultiMcqCodeURL = "mcqdone/insertMultiMcqCode"
export const fetchMCQDoneByIdURL = "mcqdone/findByCreatedBy"
export const fetchMCQDoneURL = "mcqdone/updateMcq"
export const deleteMCQURL = "mcqdone/deleteMcq"
export const uploadAssessmentURL = "mcqdone/uploadAssessment"
export const lifeForcesLogURL = "mcqdone/lifeForcesLog"
export const insertLifeForcesLogURL = "mcqdone/insertLifeForcesLog"
export const patientsURL = "patients"
export const activityURL = "activities"
export const updatePatientManualConsentURL =
    "callLogs/updatePatinetManualConsentAsDone"
export const updateSummaryStatusURL = "updateSummaryStatus"
export const getPatientDetailsURL = "getPatientDetails"
export const getMedicationsURL = "medication"
export const getConditionsURL = "condition"
export const addOrUpdatePatientConditionURL = "patientcondition/addOrUpdate"
export const addOrUpdatePatientMedicationURL = "patientmedication/addOrUpdate"
export const bulkUpdatePatientConditionURL = "patientcondition/bulk/update"
export const bulkUpdatePatientMedicationURL = "patientmedication/bulk/update"
export const getPatientMedicatonURL = "patientmedication"
export const getPatientConditionURL = "patientcondition"
export const fetchRejectedPatientSummaryListURL =
    "fetchRejectedPatientSummaryList"
export const updatePatientSummaryRejectedReasonURL =
    "updatePatientSummaryRejectedReason"
export const getPatientViewPreferenceRequestURL =
    "getPatientViewPreferenceRequest"
export const insertOrUpdatePatientViewPreferenceRequestURL =
    "insertOrUpdatePatientViewPreferenceRequest"
//----statss
// export const monthlyPerformanceReportURL = "monthlyreport/getMonthlyPerformanceReport"
// export const monthlyPerformanceReportForOrgURL = "monthlyreport/getMonthlyPerformanceReportForOrg"
// export const monthlyPerformanceReportForOrgClinicURL = "monthlyreport/getMonthlyPerformanceReportForClinic"
export const getDashboardStatsURL = "dashboard/getDashBoardStats"
export const patientsOverviewURL = "monthlyreport/getPatientsOverview"
export const revenueSplitReportURL = "monthlyreport/revenueSplitReport"
export const patientUploadLogURL = "user/patientUploadLog"
export const updatePaymentsURL = "updatePayments"
export const getPaymentIntentDetailsURL = "getPaymentIntentDetails"
export const sendOtpToLoginPhoneURL = "user/sendOtpToLoginPhone"
export const getAutoAddedNotesURL = "getAutoAddedNotes"
export const fetchClinicBasedBHNListURL = "fetchClinicBasedBHNList"
export const archiveFiles = "archive/getStoredDocuments"
export const archiveClaims = "archive/getclientOldClaims"
export const archiveInvoices = "archive/getclientOldInvoices"

//insurance
export const getCMS1500FormDetailsUrl = "getCMS1500FormDetails"
export const updateModifierDetails = "updateModifierDetails"
export const appointmentCMS1500 = "appointments/appointmentCMS1500"
//---todo or tasks
export const insertOrUpdateTodoURL = "tasks/insertOrUpdateTodoList"
export const getTodoByIdURL = "tasks/findByCreatedBy"
export const deleteTask = "tasks/deleteTask/"

//-------logTransaction
export const transactionLog = "logTransaction"

//------lookups
export const lookupsURL = "lookups"

//-----patient food dosha (Food & Dosha Impact result)
export const patientFoodDoshaURL = "patientfooddosha"

//-----consultants
export const consultantsURL = "consultants"
export const updateUserURL = "user/updateUserAccount"

//--- appointments
export const getAppointments = "appointments"
export const getAttendeeSuggestions = "appointments/getAttendences"
export const getAttendeeSuggestionsForMessageCenter =
    "appointments/getAttendencesForMessageCenter"
export const getAppointmentSlots = "appointments/appointmentSlots"
export const putAppointmentStatus = "appointments/appointmentStatus"
export const cancelordeletemultipleAppointments =
    "appointments/cancelordeletemultipleAppointments"
export const updateGoogleCalendarEvent =
    "appointments/updateGoogleCalendarEvent"
export const getUpcomingAppointmentsURL = "appointments/getUpcomingAppointment"
export const sendAppointmentPaymentLinkURL =
    "appointments/sendAppointmentPaymentLink"
export const sendAppointmentCreationSMSURL =
    "appointments/sendAppointmentCreationSMS"
export const sendAppointmentCreationEmailURL =
    "appointments/sendAppointmentCreationEmail"
export const getAppointmentPaymentDetailsURL =
    "appointments/getAppointmentPaymentDetails"
export const updateAppointmentPaymentsURL =
    "appointments/updateAppointmentPayments"
export const sendAppointmentLink = "appointment/reSendAppointmentLink"
export const getAppointmentReasons = "appointments/reason"
export const getIcdCodesUrl = "/getICDCODES"
export const getClaimPayerListUrl = "appointments/claimPayerList"
export const updateAppointmentStatusManuallyUrl =
    "appointments/updateAppointmentStatusManually"
export const insertReceiptUrl = "appointments/insertReceipt"
export const updateReceiptUrl = "appointments/updateReceipt"
export const refundReceiptUrl = "appointments/refundReceipt"
export const getMultiAppointmentPaymentDetailsURL =
    "appointments/getMultiAppointmentPaymentDetails"
export const updateMultiPaymentsURL = "updateMultiPayments"
export const getLatestCompletedAppointmentUrl =
    "appointments/getLatestCompletedAppointment"
export const getUserAppointmentTypeUrl = "appointments/userAppointmentType"
export const insertOrUpdateUserAppointmentTypeUrl =
    "appointments/insertOrUpdateUserAppointmentType"

//-----twilio
export const retrieveCallURL = "retrieve_call/"
export const appointmentURL = "appointments"

//Notes
export const notesURL = "notes"
export const notesTemplate = "getTemplate"
export const tempNotesURL = "tempNotes"
export const fetchAllNotesURL = "getAllNotes"
export const getNotesTemplatesURL = "getNotesTemplates"
export const emailCCMResponse = "email/CCMResponsesToClinic"
export const updateReviewStatusForAutoAddedNotesURL =
    "updateReviewStatusForAutoAddedNotes"
export const updateSupervisorReviewStatusForAutoAddedNotesURL =
    "updateSupervisorReviewStatusForAutoAddedNotes"

//----care plan
export const careGoalURL = "caregoal"
export const addShortTermGoalsURL = "caregoal/addShortTermGoals"
export const getShortTermGoalLogsURL = "caregoal/getLogsByShortTermGoalId"
export const updateShortTermGoalStatusURL = "caregoal/updateStatus"
export const approveShortTermGoalStatusURL = "caregoal/shortGoalUpdate"
export const patientCareGoalURL = "caregoal/findByPatientUserId"
export const activityUrl = "journal/add"
export const journalURL = "journal"
export const multipleActivityUrl = "journal/addjournals"
export const fetchCareActivitiesURL = "journal/getActiveJournalBycareGoalId"
export const markascompleatedMulti = "api/journaltracker/markascompleatedMulti"
export const tracker = "api/journaltracker/getActiveByPatientAndCategory"
export const FetchCarePlanFromBackend = "aipatient"
export const bulkUpdateCareplanUrl =
    "api/journaltracker/updateCareplanBasedOnLookup"
export const fetchAllCareActivities = "careActivities/findByProgramId"

//videos
export const videosURL = "video/getwithUserId"
export const uploadVideosURL = "video/uploadVideos"

//graphs
export const performanceReportGraphURL = "graph/performanceBeakUp"
export const engagementBreakupGraphURL = "graph/engagementBeakUp"
export const consentBreakupGraphURL = "graph/consentBeakUp"
export const assessmentBreakupGraphURL = "graph/patinetAssesmentScore"

//screen 54
export const overviewURL = "screen_54"

//call logs
export const callLogsURL = "callLogs"
export const callLogsUpdate = "callLogs/updateCallLog"
export const callLogsPatientURL = "callLogs/patient"
export const inpersonViewUpdateURL = "conversation/media/updateViewed"
export const getCallLogWithFileId = "callLogs/getWithFileId"
export const getMediaWithPatientId = "conversation/media/getWithFileId"
// export const callLogsURL = "callLogs/getTwilioLogs"
export const updatedCallLogsURL = "callLogs/getTwilioLogs"
export const callLogsViewUpdateURL = "callLogs/updateViewed"
export const getTwilioLogsURL = "callLogs/getTwilioLogs"
export const inboundCallLogsURL = "callLogs/getInboundCallLog"
export const outboundCallLogsURL = "callLogs/getOutBoundCallLog"
export const transcriptsURL = "callLogs/transcript"
export const insertSaasCallURL = "callLogs/insertSaasCall"
export const updateSaasCallURL = "callLogs/updateSaasCall"
export const getSassCallURL = "callLogs/getSaasCall"
export const getAllCommunicationLogsUrl = "getAllCommunicationLogs"
export const getPendingAmountForTheUserUrl = "getPendingAmountForTheUser"

export const emotionURL = "user/emotion"

// marketing
export const marketingSMSsentURL = "marketingSMSsent"
export const marketingsmsURL = "user/marketingsms"

//ai response storing API
export const aiResponseURL = "aipatient"
export const aiDisplayingURL = "aipatient/getPatientLatestRecord"
export const aipatientHeadersURL = "aipatient/getPatientLatestHeader"
export const docAssisstAnswersURL = "aipatient/getPatientHeaderForLookup"
export const aiCaregoalURL = "aipatient/getById"
export const overviewHeaderURL = "aipatient/getPatientLatestOverviewAIHeaders"

//notificationss

export const notifications = "user/patient/smsconsent?lookupId=101300001"
export const updateNotificationURL = "user/patient/smsconsent"
export const intimatePatientEmergencyURL = "user/intimatePatientEmergency"
export const intimateUserEmailURL = "user/intimateUserEmail"
export const sendSmsToPatientURL = "user/patient/sms"
export const getEmergencyTemplateURL = "user/getEmergencyTemplate"
export const getMessageCenterTemplateURL = "user/getMessageCenterTemplate"
export const getRoleBasedPrivilegesURL = "user/getRoleBasedPrivileges"
export const updatePrivilagesForTheRoleURL = "role/updatePrivilagesForTheRole"
export const itSupportEmailURL = "user/itsupportemail"
export const hardAlertemailURL = "user/hardAlertemail"
export const sendPushNotificationUrl = "user/sendUserPushNotification"
export const consentSms = "user/consentSms"

//reports

export const monthlyConsentGlobal = "/monthlyreport/getConsentGlobalLevel"
export const consentReportURL = "/monthlyreport/getConsentReport"
export const getPerformanceReportBeakDown =
    "/monthlyreport/getPerformanceReportBeakDown"
export const aptReportURL = "/monthlyreport/getAppointmentReport"
export const lastCareGivenClientListURL =
    "/monthlyreport/lastCareGivenClientList"

export const carePerformanceReportURL = "/monthlyreport/getPerformanceReport"

export const bhnReportURL = "/consult/report"
export const bhnTimeReportURL = "monthlyreport/getBhnsTimeSpent"

export const mstReportURL = "/monthlyreport/getmcqDoneReport"

export const carePlanReportURL = "/monthlyreport/getJournalMonthLyReport"

export const getPatientLevelPerformanceReport =
    "/monthlyreport/getDetailsOfPatientUnderCarePerformanceReport"
export const downloadAllReportURL = "/reportdownload/getConsentReport"
export const billablePatientStatusCountURL =
    "/monthlyreport/billablePatientStatusCount"
export const revenueReportURL = "/monthlyreport/getMonthlyRevenueReport"
export const appointmentsReportURL = "monthlyreport/appointmentStatusCount"
export const appointmentMetricsReportURL =
    "monthlyreport/appointmentMetricsReport"
export const staffPerformanceReportURL = "monthlyreport/staffPerformanceReport"
export const staffCancellationsReportURL =
    "monthlyreport/staffCancellationsReport"
export const salesByServiceReportURL = "monthlyreport/salesByServiceReport"
export const clientsReportURL = "monthlyreport/clientsReport"
export const clientsProgressURL = "monthlyreport/clientsEmotionProgress"
export const consultantPatientCareCountUrl =
    "monthlyreport/consultantPatientCareCount"
export const consultantProductivityUrl = "monthlyreport/consultantProductivity"
export const cumulativeTrackingSheetReportURL =
    "monthlyreport/casCumulativeTrackingSheet"

//api endpoints for docassist
// export const docAssistAddData = "/add_data"
// export const docAssistTrain = "/train"
// export const docAssistAsk = "/ask"

// patient billing summary
export const patientDemographic = "/getPatientDemographic"
export const patientAssessmentNamesScores = "/getPatientMoodScore"
export const patientSummaryNotes = "/getPatientNotes"
export const patientCarePercent = "/getPatientCarePercent"
export const patientAssessmentResponses = "/getAssessmentResponses"
export const patientAppointment = "/getAppointments"
export const patientCareGoals = "/getCareGoals"
export const patientFooter = "/getPatientClinicDetails"
export const getOrganizationTemplate = "/fetchPatientSummaryTemplate"
export const saveOrgTemplate = "/insertPatientSummaryTemplate"
export const shareViaEmail = "/sendBillableList"
export const patientCptCode = "/fetchCPTCodesBasedOnProgram"
export const generatePatientSummaryAtPatientLevelURl =
    "/generatePatientSummaryAtPatientLevel"
export const fetchServiceDateUrl = "/getPatientServiceDate"
export const getPatientSummaryListUrl = "/getPatientSummaryList"
export const fetchCPTCodes = "/getCPTCODES"
export const insertPatientCptCodeUrl = "/insertPatientCptCode"
export const fetchSummaryCptCodesUrl = "/getPatientCPTCODESList"
export const fetchSummaryIcdCodesUrl = "/getPatientICDCODESList"
export const downloadReceiptUrl = "appointments/downloadReceipt"

//assessments
export const getAssessments = "mcqdone/getAssesesments"
export const createAssessment = "mcqdone/insertMCQSInAssessmentCustom"
export const editAssessmentUrl = "mcqdone/editAssesesment"
export const assessmentrangedescurl = "mcqdone/getMCQScoreRangeAndDescription"
export const insertassessmentrangedescurl =
    "mcqdone/insertMCQScoreRangeAndDescription"
export const updateassessmentrangedescurl =
    "mcqdone/updateMCQScoreRangeAndDescription"

// saas
export const getSaasUserUrl = "saas/getSaasUser"
export const latestSummary =
    "conversation/media/getLatestRecordFromBothCallLogAndMedia"

export const suggestedICD = "getICDCODES"
export const getDSMCodesUrl = "getDSMCODES"
export const sessionAnalysis = "SessionGuidanceOutcome"
export const insertSaasUsersAppointmentUrl =
    "appointments/insertSaasUsersAppointment"
export const addIcdCodeUrl = "/insertOrUpdateICDCODES"
export const userAssessmentMapUrl = "user/userAssessmentMap"

export const getPaymentsAtClinicLevelUrl = "getPaymentsAtClinicLevel"

// subscription
export const fetchSubscriptionPricingUrl = "fetchSubscriptionPricing"
export const fetchSubscriptionLicenseUrl = "fetchSubscriptionLicense"
export const getUsersUnderOrgLevelUrl = "user/getUsersUnderOrgLevel"

// herbal formulas
export const herbalFormulaUrl = "herbal-formula"
export const herbalOrderUrl = "herbal-order"
export const patientPrescriptionsUrl = "patient-prescriptions"

// handout materials
export const handoutMaterialsURL = "handoutMaterials"
export const uploadHandoutMaterialURL = "handoutMaterials/insertOrUpdate"
export const deleteHandoutMaterialURL = "handoutMaterials/delete"

// ReReview History (assessments, treatment plan goals, formulas, prescriptions)
export const fetchStatusHistoryURL = "fetchStatusHistory"
export const createStatusHistoryURL = "createStatusHistory"
